import Vue from 'vue'
import VueRouter from 'vue-router'
import { isUserLoggedIn } from '@/auth/utils'
import { canNavigate } from '@/libs/acl/routeProtection'
import { getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'

import { locations, holiday } from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
	mode: 'history',
	scrollBehavior() {
		return { x: 0, y: 0 }
	},
	routes: [
		...locations,
		...holiday,
		{
			path: '/login',
			name: 'auth-login',
			component: () => import('@/views/Login.vue'),
			meta: {
				layout: 'full',
				resource: 'Auth',
				redirectIfLoggedIn: true,
			},
		},
		{
			path: '/error-404',
			name: 'error-404',
			component: () => import('@/views/error/Error404.vue'),
			meta: {
				layout: 'full',
				resource: 'Home',
			},
		},
		{
			path: '/not-authorized',
			name: 'misc-not-authorized',
			component: () => import('@/views/error/NotAuthorized.vue'),
			meta: {
				layout: 'full',
				resource: 'Home',
			},
		},
		{
			path: '/forgot-password',
			name: 'auth-forgot-password-v2',
			component: () => import('@/views/auth/ForgotPassword-v2.vue'),
			meta: {
				layout: 'full',
				resource: 'Auth',
			},
		},
		{
			path: '/reset-password',
			name: 'auth-reset-password-v2',
			component: () => import('@/views/auth/ResetPassword-v2.vue'),
			meta: {
				layout: 'full',
				resource: 'Auth',
				redirectIfLoggedIn: true,

			},
		},
		{
			path: '/first-password',
			name: 'auth-first-password-v2',
			component: () => import('@/views/auth/FirstPassword-v2.vue'),
			meta: {
				layout: 'full',
				resource: 'Auth',
				redirectIfLoggedIn: true,

			},
		},
		{
			path: '*',
			redirect: 'error-404',
		},
	],
})

router.beforeEach((to, _, next) => {

	const isLoggedIn = isUserLoggedIn()
	if (!canNavigate(to)) {
		// Redirect to login if not logged in
		if (!isLoggedIn) {
			return next({ name: 'auth-login' })
		}
		// If logged in => not authorized
		return next({ name: 'misc-not-authorized' })
	}

	// Redirect if logged in
	if (to.meta.redirectIfLoggedIn && isLoggedIn) {
		const userData = getUserData()
		next(getHomeRouteForLoggedInUser('super-admin'))
	}
/* 	if (_.$msalInstance) {
		if (!_.$msalInstance.getActiveAccount() && _.$msalInstance.getAllAccounts().length > 0) {
			_.$msalInstance.setActiveAccount(_.$msalInstance.getAllAccounts()[0]);
		}
		_.$msalInstance.addEventCallback((event) => {
			if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
				const account = event.payload.account;
				_.$msalInstance.setActiveAccount(account);
			}

			if (event.eventType === EventType.LOGOUT_SUCCESS) {
				if (_.$msalInstance.getAllAccounts().length > 0) {
					_.$msalInstance.setActiveAccount(_.$msalInstance.getAllAccounts()[0]);
				}
			}

			if (event.eventType === EventType.LOGIN_FAILURE) {
				console.log(JSON.stringify(event));
			}
		});
	} */
	return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
	// Remove initial loading
	const appLoading = document.getElementById('loading-bg')
	if (appLoading) {
		appLoading.style.display = 'none'
	}
})

export default router
